/**
 * Google tag (gtag.js) safety net.
 *
 * The Google tag is normally declared in index.html. Because index.html is part
 * of the project source, it is preserved across re-publishes. This loader is a
 * belt-and-braces guarantee: it makes sure the tag is present even if the static
 * snippet is ever missing from the served HTML, WITHOUT ever loading it twice.
 */
const GA_MEASUREMENT_ID = "G-26FLC1JT7E";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    __lahariGaChecked?: boolean;
  }
}

/** Ensure the Google tag is loaded exactly once. Safe to call on every boot. */
export function ensureGoogleAnalytics(): void {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (window.__lahariGaChecked) return;
  window.__lahariGaChecked = true;

  // The index.html snippet defines window.dataLayer synchronously. If it is
  // present the static tag is already handling everything — never double-load.
  if (Array.isArray(window.dataLayer)) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}